'use client';

import { atomWithStorage, type FanShopCheckoutOrder } from '@capsicum/common';

export const placeOrderPayloadAtom = atomWithStorage<FanShopCheckoutOrder>('placeOrderPayload', {});
